const candidatesPage = {
  en: {
    candidatesPage: {
      fillRequired: "Please fill in all required fields",
      added: "Candidate added successfully!",
      addFailed: "Failed to add candidate",
      photoUploaded: "Photo uploaded!",
      photoFailed: "Failed to upload photo",
      confirmDelete: "Are you sure you want to delete this candidate?",
      deleted: "Candidate deleted",
      deleteFailed: "Failed to delete candidate",
      electionTypes: {
        presidential: "Presidential",
        parliamentary: "Parliamentary",
        senatorial: "Senatorial",
        regional: "Regional",
        council: "Council"
      },
      title: "Candidates",
      subtitle: "Manage election candidates",
      allTypes: "All Types",
      addCandidate: "Add Candidate",
      addNewCandidate: "Add New Candidate",
      fullName: "Full Name *",
      partyName: "Party Name *",
      partyPlaceholder: "Cameroon People's Democratic Movement",
      bio: "Bio",
      bioPlaceholder: "Brief biography...",
      photo: "Photo",
      electionType: "Election Type *",
      selectElectionType: "Select election type",
      region: "Region",
      selectRegion: "Select region",
      constituency: "Parliamentary Constituency *",
      selectConstituency: "Select constituency",
      selectRegionFirst: "Select region first",
      noConstituencies: "No constituencies found",
      selectARegionFirst: "Select a region first",
      constituenciesAvailable: "{{count}} constituency(ies) available",
      inRegion: " in {{region}}",
      senatorPosition: "Position on Senator List (1-7) *",
      selectPosition: "Select position",
      positions: {
        1: "1 - List Leader (Head of List)",
        2: "2 - Second Position",
        3: "3 - Third Position",
        4: "4 - Fourth Position",
        5: "5 - Fifth Position",
        6: "6 - Sixth Position",
        7: "7 - Seventh Position"
      },
      senatorialInfo: "Senatorial elections use a list system. The winning party in {{region}} gets all 7 seats.",
      councilArea: "Council Area *",
      selectCouncil: "Select council",
      noCouncils: "No councils found",
      councilsAvailable: "{{count}} council(s) available",
      cancel: "Cancel",
      saveCandidate: "Save Candidate",
      noCandidates: "No candidates found",
      addFirst: "Add First Candidate",
      adminRequired: "Admin Access Required",
      adminOnly: "Only administrators can add or modify candidate information."
    }
  },
  fr: {
    candidatesPage: {
      fillRequired: "Veuillez remplir tous les champs obligatoires",
      added: "Candidat ajouté avec succès !",
      addFailed: "Échec de l'ajout du candidat",
      photoUploaded: "Photo téléversée !",
      photoFailed: "Échec du téléversement de la photo",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ce candidat ?",
      deleted: "Candidat supprimé",
      deleteFailed: "Échec de la suppression du candidat",
      electionTypes: {
        presidential: "Présidentielle",
        parliamentary: "Législative",
        senatorial: "Sénatoriale",
        regional: "Régionale",
        council: "Municipale"
      },
      title: "Candidats",
      subtitle: "Gérez les candidats aux élections",
      allTypes: "Tous les types",
      addCandidate: "Ajouter un candidat",
      addNewCandidate: "Ajouter un nouveau candidat",
      fullName: "Nom complet *",
      partyName: "Nom du parti *",
      partyPlaceholder: "Rassemblement démocratique du peuple camerounais",
      bio: "Biographie",
      bioPlaceholder: "Brève biographie...",
      photo: "Photo",
      electionType: "Type d'élection *",
      selectElectionType: "Sélectionnez le type d'élection",
      region: "Région",
      selectRegion: "Sélectionnez la région",
      constituency: "Circonscription législative *",
      selectConstituency: "Sélectionnez la circonscription",
      selectRegionFirst: "Sélectionnez d'abord la région",
      noConstituencies: "Aucune circonscription trouvée",
      selectARegionFirst: "Sélectionnez d'abord une région",
      constituenciesAvailable: "{{count}} circonscription(s) disponible(s)",
      inRegion: " dans {{region}}",
      senatorPosition: "Position sur la liste sénatoriale (1-7) *",
      selectPosition: "Sélectionnez la position",
      positions: {
        1: "1 - Tête de liste",
        2: "2 - Deuxième position",
        3: "3 - Troisième position",
        4: "4 - Quatrième position",
        5: "5 - Cinquième position",
        6: "6 - Sixième position",
        7: "7 - Septième position"
      },
      senatorialInfo: "Les élections sénatoriales utilisent un système de listes. Le parti gagnant dans {{region}} remporte les 7 sièges.",
      councilArea: "Circonscription municipale *",
      selectCouncil: "Sélectionnez la commune",
      noCouncils: "Aucune commune trouvée",
      councilsAvailable: "{{count}} commune(s) disponible(s)",
      cancel: "Annuler",
      saveCandidate: "Enregistrer le candidat",
      noCandidates: "Aucun candidat trouvé",
      addFirst: "Ajouter le premier candidat",
      adminRequired: "Accès administrateur requis",
      adminOnly: "Seuls les administrateurs peuvent ajouter ou modifier les informations des candidats."
    }
  }
};

export default candidatesPage;
